/**
* Плагин для форматирования чисел в соответствии с региональными настройками.
* @param {Object} Vue - Экземпляр Vue.
*/
export default {
 install(app) {
   /**
    * Форматирует число в строку с разделителями разрядов.
    * @param {number} num - Число для форматирования.
    * @returns {string} Отформатированная строка.
    */
    app.config.globalProperties.$formatNumber = function (num) {
      const [intPart, fracPart] = num.toFixed(2).split('.');
      const intWithSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return `${intWithSpaces}.${fracPart}`;
    };
 }
};
